import React, { Component } from 'react';
import Table, {TableColumn} from "./Table";
import TableCell from "./TableCell";
import {ProcessorItemDifferenceSummary} from "../models/ProcessorItemDifferenceSummary";
import {CommandBarButton} from "office-ui-fabric-react";
import ProcessorItemDetailCard from "./mailroom/ProcessorItemDetailCard";
import {ProcessorDifferencesTable} from "./ProccessorDifferencesTable";

interface ProcessorDifferencesViewerProps {
    changed: ProcessorItemDifferenceSummary[] 
}

type Mode = "differences" | "first" | "second";

interface ProcessorDifferencesViewerState {
    
    selectedSummary?: ProcessorItemDifferenceSummary;
    selectedMode: Mode
}


const columns: TableColumn[] = [
    {
        title: "ID",
        flex: 4,
        propertyPath: "ID"
    },
    {
        title: "First",
        flex: 1,
        propertyPath: "first"
    },
    {
        title: "Second",
        flex: 1,
        propertyPath: "second"
    },
    {
        title: "Differences",
        flex: 1,
        propertyPath: "differences"
    }
];

export class ProcessorDifferencesViewer extends Component<ProcessorDifferencesViewerProps, ProcessorDifferencesViewerState> {
    static displayName = ProcessorDifferencesViewer.name;

    constructor(props: ProcessorDifferencesViewerProps) {
        super(props);

        this.state = {
            selectedSummary: undefined,
            selectedMode: "differences"
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<ProcessorDifferencesViewerProps>, prevState: ProcessorDifferencesViewerState) {
    }

    
    cellForColumn = (summary: ProcessorItemDifferenceSummary, column: TableColumn, columnIndex: number) =>
    {
        
        const buildButtonCell = (mode: Mode) => {
            return (
                <TableCell flex={column.flex}>
                    <CommandBarButton
                        text={mode}
                        onClick={async () => {
                            this.setState({
                                selectedSummary: summary,
                                selectedMode: mode
                            });
                        }}
                    />
                </TableCell>
            )
        }
        
        if(column.propertyPath === "first")
        {
            return buildButtonCell("first");
        }

        if(column.propertyPath === "second")
        {
            return buildButtonCell("second");
        }

        if(column.propertyPath === "differences")
        {
            return buildButtonCell("differences");
        }
    }
    
    private renderDetailArea()
    {
        if(this.state.selectedSummary === undefined)
        {
            return null;
        }
        
        if(this.state.selectedMode === "first")
        {
            return <ProcessorItemDetailCard item={this.state.selectedSummary.firstProcessorItem} relatedItems={[]} allItems={[]} onRelatedItemSelected={() => {}}/>
        }

        if(this.state.selectedMode === "second")
        {
            return <ProcessorItemDetailCard item={this.state.selectedSummary.secondProcessorItem} relatedItems={[]} allItems={[]} onRelatedItemSelected={() => {}}/>
        }

        if(this.state.selectedMode === "differences")
        {
            return <ProcessorDifferencesTable differences={this.state.selectedSummary.differences}/>;
        }
    }
    
    render() {
        
        return (
            <div className={"flex-row flex-item--flex-1"}>
                <div className={"flex-item--flex-3"}>
                    <Table
                        className={"cdb-table__min-height-500"}
                        items={this.props.changed}
                        columns={columns}
                        virtualize={true}
                        cellForColumn={this.cellForColumn}/>
                </div>
                <div className={"flex-item--flex-5"}>
                    {this.renderDetailArea()}
                </div>
            </div>
        );
    }
}